import type { AttributeValue, Tracer } from '@opentelemetry/api'
import {
  ATTRIBUTE_NAME_AGENT_STATE_JSON,
  ATTRIBUTE_NAME_AGENT_STATE_REDACTED_PATHS_JSON,
  ATTRIBUTE_NAME_ERROR_MESSAGE,
  ATTRIBUTE_NAME_ERROR_TYPE,
  ATTRIBUTE_NAME_FRISK_TOOL_ID,
  ATTRIBUTE_NAME_FRISK_TOOL_VERSION_ID,
  ATTRIBUTE_NAME_LLM_CALL_SPAN_ID,
  ATTRIBUTE_NAME_LLM_REASONING,
  ATTRIBUTE_NAME_SESSION_ID,
  ATTRIBUTE_NAME_TOOL_ARGS_JSON,
  ATTRIBUTE_NAME_TOOL_ARGS_REDACTED_PATHS_JSON,
  ATTRIBUTE_NAME_TOOL_CALL_ID,
  ATTRIBUTE_NAME_TOOL_CALL_IS_ERROR,
  ATTRIBUTE_NAME_TOOL_CALL_IS_SUCCESS,
  ATTRIBUTE_NAME_TOOL_CALL_SEQUENCE_NUMBER,
  ATTRIBUTE_NAME_TOOL_NAME,
  SPAN_NAME_OBSERVE_TOOL_CALL,
} from '../../telemetry/constants'
import { FriskSpan } from './frisk-span'

const FIELDS = {
  sessionId: ATTRIBUTE_NAME_SESSION_ID,
  toolName: ATTRIBUTE_NAME_TOOL_NAME,
  toolCallId: ATTRIBUTE_NAME_TOOL_CALL_ID,
  toolArgsJson: ATTRIBUTE_NAME_TOOL_ARGS_JSON,
  toolArgsRedactedPathsJson: ATTRIBUTE_NAME_TOOL_ARGS_REDACTED_PATHS_JSON,
  agentStateJson: ATTRIBUTE_NAME_AGENT_STATE_JSON,
  agentStateRedactedPathsJson: ATTRIBUTE_NAME_AGENT_STATE_REDACTED_PATHS_JSON,
  toolCallSequenceNumber: ATTRIBUTE_NAME_TOOL_CALL_SEQUENCE_NUMBER,
  friskToolId: ATTRIBUTE_NAME_FRISK_TOOL_ID,
  friskToolVersionId: ATTRIBUTE_NAME_FRISK_TOOL_VERSION_ID,
  llmReasoning: ATTRIBUTE_NAME_LLM_REASONING,
  isSuccess: ATTRIBUTE_NAME_TOOL_CALL_IS_SUCCESS,
  isError: ATTRIBUTE_NAME_TOOL_CALL_IS_ERROR,
  errorMessage: ATTRIBUTE_NAME_ERROR_MESSAGE,
  errorType: ATTRIBUTE_NAME_ERROR_TYPE,
  llmCallSpanId: ATTRIBUTE_NAME_LLM_CALL_SPAN_ID,
} as const

/** Typed span for observing an executed tool call. */
export class ToolCallObservationSpan extends FriskSpan {
  constructor(args: { tracer: Tracer; parent?: FriskSpan | null }) {
    super({
      ...args,
      spanName: SPAN_NAME_OBSERVE_TOOL_CALL,
      attributeFields: FIELDS,
    })
  }

  setAttributes(values: {
    sessionId?: string
    toolName?: string
    toolCallId?: string
    toolArgsJson?: string
    toolArgsRedactedPathsJson?: string
    agentStateJson?: string
    agentStateRedactedPathsJson?: string
    toolCallSequenceNumber?: number
    friskToolId?: string
    friskToolVersionId?: string
    llmReasoning?: string
    isSuccess?: boolean
    isError?: boolean
    errorMessage?: string
    errorType?: string
    llmCallSpanId?: string
  }): void {
    this.setAttributesByField(
      values as Record<string, AttributeValue | undefined>,
    )
  }
}
